import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import {
  ITratamientoEvento,
  IComunicadorAlarma,
  IQueryParam,
  IPopulate,
  IFilter,
  ICreateTratamientoEvento,
  IEventoGenerico,
  INota,
  ICliente,
  IServicioContratado,
  EstadoEvento,
  ICamaraAlarma,
  IGeoJSONPoint,
  IReporteGenerico,
  TipoEventoGenerico,
  EstadoEventoTecnico,
  IValoresEventoTecnico,
  ICertificadoEntidad,
  IMaterialServicioTecnico,
  IUsuario,
  ICodigosSeguridadContacto,
} from 'modelos/src';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { NotasService } from '../../../../../auxiliares/servicios/http/notas.service';
import { isModoDesactivadoActivo } from '../../../../../auxiliares/modo-desactivado.util';
import {
  AgregarNotaGenericoComponent,
  IAgregarNotaGenericoData,
} from '../agregar-nota-generico/agregar-nota-generico.component';
import { PonerEnEsperaGenericoComponent } from '../poner-en-espera-generico/poner-en-espera-generico.component';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { LoginService } from '../../../../login/login.service';
import {
  EmergenciaAvlDialogComponent,
  IEmergenciaAvlData,
} from '../../../administracion/config-reenvios/emergencia-avl-dialog/emergencia-avl-dialog.component';
import { MapaFacilDialogComponent } from '../../../../../auxiliares/mapa-facil-dialog/mapa-facil-dialog.component';
import { MapaFacilData } from '../../../../../auxiliares/mapa-facil/interfaces';
import { OverlayContainer } from '@angular/cdk/overlay';
import { TratamientoEventosService } from '../../../../../auxiliares/servicios/http/tratamientos-eventos.service';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { CamarasMultipleComponent } from '../../../../standalone/camaras-multiple/camaras-multiple.component';
import { HistoricoEventoGenericoDialogComponent } from '../historico-evento-generico-dialog/historico-evento-generico-dialog.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { EventosTecnicosGenericoDispositivoComponent } from '../../eventos-tecnicos-genericos/eventos-tecnicos-dispositivo/eventos-tecnicos-generico-dispositivo.component';
import { AsignarGenericoComponent } from '../../../administracion/eventos-tecnicos-genericos/asignar/asignar.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { EnviarMovilComponent } from '../enviar-movil/enviar-movil.component';
import { TriperoService } from '../../../../../auxiliares/servicios/http/tripero.service';
import { Router } from '@angular/router';
import { MapaVehiculosService } from '../../../vehiculos/contenedor-mapa/mapaVehiculos.service';
import { TratamientoMinimizadoService } from '../tratamiento-minimizado.service';
import { CertificadoEntidadService } from '../../../../../auxiliares/servicios/http/certificado-entidad.service';
import { VerCertificadoEntidadComponent } from '../../../../standalone/certificado-entidad/ver-certificado-entidad/ver-certificado-entidad.component';
import { ModeloDispositivoSelectorCacheService } from '../../../../../componentes/selectores/modelo-dispositivo-selector/modelo-dispositivo-selector-cache.service';

export interface ITratamientoGenericoData {
  idEvento: string;
}

@Component({
  selector: 'app-tratamiento-generico',
  templateUrl: './tratamiento-generico.component.html',
  styleUrl: './tratamiento-generico.component.scss',
  standalone: false,
})
export class TratamientoGenericoComponent implements OnInit, OnDestroy {
  private dialogData = inject<ITratamientoGenericoData>(MAT_DIALOG_DATA);
  data!: IEventoGenerico;
  private modeloCache = inject(ModeloDispositivoSelectorCacheService);
  /** comunicadores[] de la alarma con `.modelo` resuelto por idComunicador. */
  comunicadoresResueltos: IComunicadorAlarma[] = [];
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  private dialogRef =
    inject<MatDialogRef<TratamientoGenericoComponent>>(MatDialogRef);
  private dialogService = inject(DialogService);
  private service = inject(TratamientoEventosService);
  private cdk = inject(OverlayContainer);
  private el = inject(ElementRef);
  private paramsService = inject(ParamsService);
  private eventosGenericosService = inject(EventosGenericosHttpService);
  private router = inject(Router);
  private certificadoEntidadService = inject(CertificadoEntidadService);
  private notasService = inject(NotasService);

  public loading: boolean = true;
  public dragBoundary: HTMLElement | null = null;

  public tratando: boolean = false;
  /** Usuarios que están atendiendo los eventos del dispositivo */
  public usuariosAtendiendo: IUsuario[] = [];
  public estadoActual?: EstadoEvento;
  public estadoActualTecnico?: EstadoEventoTecnico;
  public evento: IEventoGenerico;
  public eventosDispositivo: IEventoGenerico[];
  public ultimosEventos: IEventoGenerico[];
  public ultimosEventos$: Subscription;
  public idsEventosDispositivoSeleccionados?: string[];
  public evento$: Subscription;
  public cliente: ICliente;
  public cliente$: Subscription;
  public servicioTecnicoActivo$: Subscription;
  public servicioTecnicoActivo?: IEventoGenerico;
  public estadoServicioTecnico?: 'Pendiente' | 'Asignado';
  public estadoDeCuenta?: string = 'Al día';

  // Estado de cuenta y servicios solo aplican a entidades con abonado/servicios:
  // alarma, activo (vehículo/colectivo) y tracker. No a luminarias, gateways, etc.
  public get aplicaEstadoCuentaYServicios(): boolean {
    return !!(
      this.evento?.alarma ||
      this.evento?.activo ||
      this.evento?.tracker
    );
  }
  public serviciosContratados: IServicioContratado[] = [];
  public serviciosContratados$: Subscription;
  public mostrandoCamara: boolean = false;
  public tratamientosEvento: ITratamientoEvento[] = [];
  public tratamientosEvento$: Subscription;
  public notas: INota[] = [];
  public contactos: INota[] = [];
  public notas$: Subscription;

  // Códigos de seguridad de contactos: se piden bajo demanda (endpoint
  // dedicado, no vienen en el listado de notas/contactos) y se guardan acá
  // por id de contacto, igual que en el diálogo de detalles de nota.
  private cargandoCodigosSeguridad = new Set<string>();
  private codigosSeguridadRevelados = new Map<
    string,
    ICodigosSeguridadContacto
  >();
  public materiales: IMaterialServicioTecnico[] = [];
  public materiales$: Subscription;
  public ultimoReporte: IReporteGenerico;
  public ultimoReporte$: Subscription;

  public camaraInicialAlarma: ICamaraAlarma = null;
  public direccion: string = '';

  public tieneCamaras = signal(false);
  public ultimoCertificado: ICertificadoEntidad | null | undefined = undefined;

  private triperoService = inject(TriperoService);
  private mapaVehiculosService = inject(MapaVehiculosService);
  private tratamientoMinimizado = inject(TratamientoMinimizadoService);

  /** Modo desactivado vigente de la entidad asociada (activo o alarma) */
  public get dispositivoEnModoDesactivado(): boolean {
    return isModoDesactivadoActivo(
      (this.data?.activo ?? this.data?.alarma)?.modoDesactivado,
    );
  }

  /** Imágenes de la entidad asociada (activo, alarma o tracker), sin huecos */
  public get imagenesEntidad(): string[] {
    const imgs =
      this.data?.alarma?.imagenes ||
      this.data?.activo?.imagenes ||
      this.data?.tracker?.imagenes ||
      [];
    return imgs.filter((url): url is string => !!url);
  }

  // Type guards y helpers para acceso seguro a valores
  public getMensaje(): string {
    // Todos los tipos de eventos tienen mensaje en IValoresEventoBase
    return this.data?.valores?.mensaje || '';
  }

  public tieneGeojson(): boolean {
    // Para alarmas, la ubicación está en alarma.domicilio.geojson
    if (this.data.tipoEvento === 'Evento Alarma') {
      return !!(this.data.alarma?.domicilio?.geojson?.coordinates?.length >= 2);
    }

    // Para los demás tipos que tienen geojson en valores:
    // - Evento Tracker, Evento Activo, Evento Colectivo, Evento Vehiculo (IValoresEventoTracker)
    // - Evento Sirena (IValoresEventoSirena)
    // - Evento Luminaria (IValoresEventoLuminaria)
    // - Evento BotonBLE (IValoresEventoBotonBLE)
    const tiposConGeojsonEnValores = [
      'Evento Tracker',
      'Evento Activo',
      'Evento Colectivo',
      'Evento Vehiculo',
      'Evento Sirena',
      'Evento Luminaria',
      'Evento Gateway',
      'Evento BotonBLE',
    ];

    if (tiposConGeojsonEnValores.includes(this.data.tipoEvento)) {
      // Type narrowing: estos tipos tienen geojson en valores
      if (
        this.data.tipoEvento === 'Evento Tracker' ||
        this.data.tipoEvento === 'Evento Activo' ||
        this.data.tipoEvento === 'Evento Colectivo' ||
        this.data.tipoEvento === 'Evento Vehiculo' ||
        this.data.tipoEvento === 'Evento Sirena' ||
        this.data.tipoEvento === 'Evento Luminaria' ||
        this.data.tipoEvento === 'Evento Gateway' ||
        this.data.tipoEvento === 'Evento BotonBLE'
      ) {
        // Si el evento tiene geojson, retornar true
        if (this.data.valores?.geojson?.coordinates?.length >= 2) {
          return true;
        }

        // Para tracker/vehículo sin geojson en el evento, verificar último reporte
        const tiposConUltimoReporte = [
          'Evento Tracker',
          'Evento Activo',
          'Evento Colectivo',
          'Evento Vehiculo',
        ];
        if (tiposConUltimoReporte.includes(this.data.tipoEvento)) {
          // Verificar que el último reporte sea de tipo Tracker 4G que tiene geojson
          if (this.ultimoReporte?.tipoReporte === 'Tracker 4G') {
            const valores = this.ultimoReporte.valores as {
              geojson?: IGeoJSONPoint;
            };
            return !!(valores?.geojson?.coordinates?.length >= 2);
          }
        }

        return false;
      }
    }

    // Para otros tipos de eventos (técnicos, emergencias, etc.) no tienen geojson
    return false;
  }

  public getGeojsonCoordinates(): number[] | undefined {
    // Solo los eventos con geojson en valores
    if (
      this.data.tipoEvento === 'Evento Tracker' ||
      this.data.tipoEvento === 'Evento Activo' ||
      this.data.tipoEvento === 'Evento Colectivo' ||
      this.data.tipoEvento === 'Evento Vehiculo' ||
      this.data.tipoEvento === 'Evento Sirena' ||
      this.data.tipoEvento === 'Evento Luminaria' ||
      this.data.tipoEvento === 'Evento Gateway' ||
      this.data.tipoEvento === 'Evento BotonBLE'
    ) {
      return this.data.valores?.geojson?.coordinates;
    }
    return undefined;
  }

  public getValoresTecnicos(): IValoresEventoTecnico | undefined {
    if (this.esEventoTecnico()) {
      return this.data.valores as IValoresEventoTecnico;
    }
    return undefined;
  }

  public getDiasTexto(dias?: string[]): string {
    if (!dias || dias.length === 0) return 'Todos los días';

    const diasOrdenados = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo',
    ];
    const diasFiltrados = diasOrdenados.filter((dia) => dias.includes(dia));

    if (diasFiltrados.length === 7) return 'Todos los días';
    if (
      diasFiltrados.length === 5 &&
      !diasFiltrados.includes('Sábado') &&
      !diasFiltrados.includes('Domingo')
    ) {
      return 'Lunes a Viernes';
    }
    if (
      diasFiltrados.length === 2 &&
      diasFiltrados.includes('Sábado') &&
      diasFiltrados.includes('Domingo')
    ) {
      return 'Fines de semana';
    }

    return diasFiltrados.join(', ');
  }

  //LISTADOS
  private async listarMateriales(): Promise<void> {
    if (!this.esEventoTecnico() || !this.data._id) {
      return;
    }
    const filter: IFilter<IMaterialServicioTecnico> = {
      idEventoGenerico: this.data._id,
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      populate: JSON.stringify({
        path: 'usuario',
        select: 'usuario datosPersonales',
      }),
      sort: '-fechaCreacion',
    };
    return new Promise<void>((resolve) => {
      this.materiales$?.unsubscribe();
      this.materiales$ = this.lista2
        .materialesServicioTecnico(query, 30)
        .subscribe((data) => {
          this.materiales = data.datos;
          resolve();
        });
    });
  }

  private async listarNotas(): Promise<void> {
    const idEntidad = this.data.idEntidad;

    if (!idEntidad) {
      return;
    }

    return new Promise<void>((resolve) => {
      const idCliente = this.data.cliente?._id;
      const filter: IFilter<INota> = {
        idAsignado: { $in: [idEntidad, idCliente] },
        $or: [
          { permanente: true },
          {
            vigenciaDesde: { $lte: new Date().toISOString() },
            vigenciaHasta: { $gte: new Date().toISOString() },
          },
        ],
      };
      const populate: IPopulate = {
        path: 'categoriaEvento',
        select: 'nombre color',
      };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        populate: JSON.stringify(populate),
        sort: 'orden',
      };
      const categoriaDelEvento = this.data.categoria;
      // Partición real del evento. Si el protocolo no la informa (undefined),
      // se asume partición 0 (sistema/zona sin particionado real) en vez de
      // dejar de filtrar por partición.
      const particionDelEvento =
        this.data.tipoEvento === 'Evento Alarma'
          ? +(this.data.valores?.contactId?.numeroDeParticion ?? 0)
          : 0;
      const coincideCategoria = (nota: INota) =>
        !nota.categoriaEvento ||
        nota.categoriaEvento.nombre === categoriaDelEvento;
      // Partición 0 (o sin partición) = evento de sistema / panel sin
      // particionado: aplica a todas las notas y contactos, tengan la
      // partición que tengan. Los protocolos ContactID mandan "00" en eventos
      // de sistema (AC, batería, test, tamper), así que filtrar por igualdad
      // estricta dejaba fuera a todos los contactos de particiones reales.
      const coincideParticion = (nota: INota) => {
        if (!particionDelEvento) return true;
        const particionNota = nota.informacion?.particion;
        if (particionNota === undefined || particionNota === null) return true;
        // Partición 0 en la nota se trata como "sin indicar" (el form la deja
        // vacía y el chip no se muestra) → aplica a cualquier partición.
        if (!+particionNota) return true;
        return +particionNota === particionDelEvento;
      };
      // Aplica: las que no tienen categoría/partición asignada (para todos los eventos/particiones)
      // o las que coinciden con la categoría y partición del evento que se está tratando
      const aplicaAlEvento = (nota: INota) =>
        coincideCategoria(nota) && coincideParticion(nota);
      // Prioriza las más específicas (coinciden en categoría y/o partición) por sobre las genéricas
      const porPrioridad = (a: INota, b: INota) => {
        const especificidad = (nota: INota) =>
          (nota.categoriaEvento?.nombre === categoriaDelEvento ? 1 : 0) +
          (nota.informacion?.particion !== undefined &&
          nota.informacion?.particion !== null &&
          +nota.informacion.particion === particionDelEvento
            ? 1
            : 0);
        const diff = especificidad(b) - especificidad(a);
        if (diff !== 0) return diff;
        return (a.orden ?? 0) - (b.orden ?? 0);
      };
      this.notas$?.unsubscribe();
      this.notas$ = this.lista2.notas(query).subscribe((data) => {
        // Filtrado de notas y contactos
        this.notas = data.datos
          .filter((nota) => nota.tipo === 'Nota')
          .filter(aplicaAlEvento)
          .sort(porPrioridad);
        const now = new Date().toISOString();
        this.contactos = data.datos
          .filter((nota) => nota.tipo === 'Contacto')
          .filter(aplicaAlEvento)
          .filter((contacto) => {
            // Filtrar contactos inhabilitados en el período actual
            if (contacto.inhabilitadoDesde && contacto.inhabilitadoHasta) {
              return (
                now < contacto.inhabilitadoDesde ||
                now > contacto.inhabilitadoHasta
              );
            }
            return true;
          })
          .sort(porPrioridad);
        resolve();
      });
    });
  }

  private async listarCliente(): Promise<void> {
    return new Promise<void>((resolve) => {
      const idCliente = this.data.cliente?._id;
      const filter: IFilter<ICliente> = {
        $and: [{ _id: idCliente }],
      };
      const populate: IPopulate = {};
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        select: 'nombre estadoDeCuenta',
        populate: JSON.stringify(populate),
        includeChildren: true,
      };
      this.cliente$?.unsubscribe();
      this.cliente$ = this.lista2.clientes(query).subscribe((data) => {
        this.cliente = data.datos[0];
        // this.estadoDeCuenta = this.cliente.estadoDeCuenta;
        resolve();
      });
    });
  }

  private async listarTratamientos(): Promise<void> {
    if (!this.idsEventosDispositivoSeleccionados?.length) {
      return;
    }
    if (!this.esEventoTecnico()) {
      return new Promise<void>((resolve) => {
        const populate: IPopulate[] = [
          {
            path: 'usuario',
            select: 'usuario',
          },
        ];
        const filter: IFilter<ITratamientoEvento> = {
          idsEventos: { $in: this.idsEventosDispositivoSeleccionados },
          estado: { $ne: 'Sin Tratamiento' },
        };
        const query: IQueryParam = {
          filter: JSON.stringify(filter),
          populate: JSON.stringify(populate),
          sort: '-fechaCreacion',
        };
        this.tratamientosEvento$?.unsubscribe();
        this.tratamientosEvento$ = this.lista2
          .tratamientos(query, 30)
          .subscribe((data) => {
            this.tratamientosEvento = JSON.parse(JSON.stringify(data.datos));

            // Si hay tratamientos, usar el estado del más reciente
            if (this.tratamientosEvento.length > 0) {
              this.estadoActual = this.tratamientosEvento[0]
                ?.estado as EstadoEvento;
              if (this.estadoActual === 'Finalizada') {
                // revisar si no hay algun evento sin finalizar colado
                const existe = this.eventosDispositivo.find(
                  (e) => e.estado !== 'Finalizada',
                );
                if (existe) this.estadoActual = existe.estado as EstadoEvento;
                else this.estadoActual = 'Finalizada';
              }
            } else {
              // Si no hay tratamientos, usar el estado del primer evento
              if (this.eventosDispositivo.length > 0) {
                this.estadoActual = this.eventosDispositivo[0]
                  .estado as EstadoEvento;
              }
            }
            resolve();
          });
      });
    } else {
      // Lógica para eventos técnicos
      return new Promise<void>((resolve) => {
        const populate: IPopulate[] = [
          {
            path: 'usuario',
            select: 'usuario',
          },
        ];
        const filter: IFilter<ITratamientoEvento> = {
          idsEventos: this.data._id,
          estadoTecnico: { $ne: 'Sin Tratamiento' },
        };
        const query: IQueryParam = {
          filter: JSON.stringify(filter),
          populate: JSON.stringify(populate),
          sort: '-fechaCreacion',
        };
        this.tratamientosEvento$?.unsubscribe();
        this.tratamientosEvento$ = this.lista2
          .tratamientos(query, 30)
          .subscribe((data) => {
            this.tratamientosEvento = JSON.parse(JSON.stringify(data.datos));

            // Si hay tratamientos, usar el estadoTecnico del más reciente
            if (this.tratamientosEvento.length > 0) {
              this.estadoActualTecnico = this.tratamientosEvento[0]
                ?.estadoTecnico as EstadoEventoTecnico;
              if (this.estadoActualTecnico === 'Finalizado') {
                // revisar si no hay algun evento sin finalizar colado
                const existe = this.eventosDispositivo.find(
                  (e) => e.estado !== 'Finalizado',
                );
                if (existe)
                  this.estadoActualTecnico =
                    existe.estado as EstadoEventoTecnico;
                else this.estadoActualTecnico = 'Finalizado';
              }
              // Para eventos técnicos, tratando se deriva de si hay un tratamiento activo
              this.tratando = this.estadoActualTecnico !== 'Finalizado';
            } else {
              // Si no hay tratamientos, usar el estadoTecnico del primer evento
              if (this.eventosDispositivo.length > 0) {
                this.estadoActualTecnico = this.eventosDispositivo[0]
                  .estado as EstadoEventoTecnico;
              }
              this.tratando = false;
            }
            resolve();
          });
      });
    }
  }

  /** El cliente actual permite que varios operadores atiendan a la vez */
  public get atencionMultiple(): boolean {
    return LoginService.getCliente()?.config?.atencionMultipleEventos === true;
  }

  /** Sin atención múltiple, otro operador ya está atendiendo → no puedo iniciar */
  public get bloqueadoPorOtro(): boolean {
    return (
      !this.atencionMultiple &&
      !this.tratando &&
      this.usuariosAtendiendo.length > 0
    );
  }

  public get nombresAtendiendo(): string {
    return this.usuariosAtendiendo
      .map((u) => this.nombreUsuario(u))
      .filter(Boolean)
      .join(', ');
  }

  public nombreUsuario(u: IUsuario): string {
    return u?.datosPersonales?.nombre || u?.usuario || '';
  }

  public cargandoCodigosDe(idContacto: string): boolean {
    return this.cargandoCodigosSeguridad.has(idContacto);
  }

  public codigosSeguridadDe(
    idContacto: string,
  ): ICodigosSeguridadContacto | undefined {
    return this.codigosSeguridadRevelados.get(idContacto);
  }

  public async verCodigosSeguridad(contacto: INota): Promise<void> {
    const id = contacto._id;
    if (!id || this.cargandoCodigosSeguridad.has(id)) return;
    this.cargandoCodigosSeguridad.add(id);
    try {
      const codigos = await this.notasService.getCodigosSeguridad(id);
      this.codigosSeguridadRevelados.set(id, codigos);
    } catch (error) {
      this.helper.notifError(error);
    } finally {
      this.cargandoCodigosSeguridad.delete(id);
    }
  }

  public esUsuarioActual(u: IUsuario): boolean {
    return u?._id === LoginService.getUsuario()?._id;
  }

  /** El tratamiento/nota lo creó el usuario logueado */
  public esTratamientoPropio(t: ITratamientoEvento): boolean {
    const idUsuario = t?.idUsuario || t?.usuario?._id;
    return !!idUsuario && idUsuario === LoginService.getUsuario()?._id;
  }

  /** Usuarios únicos atendiendo alguno de los eventos del dispositivo */
  private actualizarUsuariosAtendiendo(eventos: IEventoGenerico[]): void {
    const usuarios = new Map<string, IUsuario>();
    for (const evento of eventos || []) {
      for (const usuario of evento.usuariosAtendiendo || []) {
        if (usuario?._id) {
          usuarios.set(usuario._id, usuario);
        }
      }
    }
    this.usuariosAtendiendo = [...usuarios.values()];
  }

  private async listarEventos(): Promise<void> {
    return new Promise<void>((resolve) => {
      const filter: IFilter<IEventoGenerico> = {
        idEntidad: this.data.idEntidad,
      };

      // No mezclar eventos técnicos con eventos regulares en "Eventos a Tratar"
      if (this.esEventoTecnico()) {
        filter.filtrador = 'Servicio Técnico';
      } else {
        filter.filtrador = { $ne: 'Servicio Técnico' } as any;
      }

      if (this.data?.estado === 'En Espera') {
        filter.estado = {
          $nin: [
            'Sin Tratamiento',
            'Pendiente',
            'En Atención',
            'Liberada',
            'Finalizada',
          ],
        } as any;
      } else {
        filter.estado = { $nin: ['Finalizada', 'En Espera'] } as any;
      }

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        includeChildren: true,
        sort: '-fechaCreacion',
        excludeTotalCount: true,
        populate: JSON.stringify([
          {
            path: 'usuariosAtendiendo',
            select: 'usuario datosPersonales.nombre',
          },
        ]),
      };
      this.evento$?.unsubscribe();
      this.evento$ = this.lista2
        .eventosGenericos(query, 30)
        .subscribe(async (data) => {
          const idsUsuariosAtendiendo = data.datos
            .map((e) => e.idsUsuariosAtendiendo)
            .flat();
          this.tratando = idsUsuariosAtendiendo?.includes(
            LoginService.getUsuario()._id,
          );
          this.actualizarUsuariosAtendiendo(data.datos);
          this.eventosDispositivo = data.datos;

          //Los datos vienen ordenados por fecha de Creación, pero necesito que sí o sí al tomar los 50 eventos, mínimamente el evento que estoy viendo esté. Y de preferencia, que esté primero.
          // Definir el valor que quieres que esté primero
          const idDeseado = this.data?._id;

          // Ordenar el array para que el dispositivo con el _id = idDeseado esté primero
          this.eventosDispositivo.sort((a, b) => {
            // Si a tiene el _id igual al idDeseado, debe ir primero
            if (a._id === idDeseado) return -1;
            // Si b tiene el _id igual al idDeseado, debe ir primero
            if (b._id === idDeseado) return 1;
            // Si ninguno de los dos tiene el _id igual al idDeseado, mantenemos el orden original
            return 0;
          });

          // Recortar el array para que solo queden los primeros 50 eventos
          this.eventosDispositivo = this.eventosDispositivo.slice(0, 50);

          if (!this.idsEventosDispositivoSeleccionados) {
            this.idsEventosDispositivoSeleccionados =
              this.eventosDispositivo.map((e) => e._id);
          }
          await this.listarTratamientos();
          resolve();
        });
    });
  }

  private async listarUltimosEventos(): Promise<void> {
    return new Promise<void>((resolve) => {
      const filter: IFilter<IEventoGenerico> = {
        idEntidad: this.data.idEntidad,
      };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        sort: '-fechaCreacion',
        excludeTotalCount: true,
        includeChildren: true,
        limit: 10,
      };

      this.ultimosEventos$?.unsubscribe();
      this.ultimosEventos$ = this.lista2
        .eventosGenericos(query, 30)
        .subscribe((data) => {
          this.ultimosEventos = data.datos;
          resolve();
        });
    });
  }

  private async listarServicios(): Promise<void> {
    return new Promise<void>((resolve) => {
      const ids: string[] = [];

      // Usar discriminadores para acceso seguro a tipos
      if (this.data.tipoEvento === 'Evento Alarma') {
        if (this.data.alarma?.idServiciosContratados) {
          ids.push(...this.data.alarma.idServiciosContratados);
        }
      } else if (this.data.tipoEvento === 'Evento Tracker') {
        if (this.data.tracker?.idServiciosContratados) {
          ids.push(...this.data.tracker.idServiciosContratados);
        }
      } else if (
        this.data.tipoEvento === 'Evento Activo' ||
        this.data.tipoEvento === 'Evento Colectivo' ||
        this.data.tipoEvento === 'Evento Vehiculo'
      ) {
        if (this.data.activo?.tracker?.idServiciosContratados) {
          ids.push(...this.data.activo.tracker.idServiciosContratados);
        }
      }

      if (ids.length === 0) {
        resolve();
        return;
      }

      const filter: IFilter<IServicioContratado> = {
        _id: {
          $in: ids,
        },
      };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        sort: 'nombre',
        select: 'nombre',
      };
      this.serviciosContratados$?.unsubscribe();
      this.serviciosContratados$ = this.lista2
        .serviciosContratados(query)
        .subscribe((data) => {
          this.serviciosContratados = data.datos;
          resolve();
        });
    });
  }

  private async listarServicioTecnicoActivo(): Promise<void> {
    let idDispositivo: string = '';
    let campoFiltro: keyof IFilter<IEventoGenerico>;
    let tipoEventoTecnico: TipoEventoGenerico;

    // Mapear el tipo de dispositivo al campo del filtro y tipo de evento técnico
    switch (this.data.tipoEvento) {
      case 'Evento Activo':
      case 'Evento Vehiculo':
      case 'Evento Colectivo':
      case 'Evento Tracker':
        // Los eventos técnicos de tracker aplican a activos, vehículos y colectivos
        idDispositivo = this.data.activo?._id || this.data.tracker?._id || '';
        campoFiltro = 'idEntidad';
        tipoEventoTecnico = 'Evento Técnico Tracker';
        break;
      case 'Evento Alarma':
        idDispositivo = this.data.alarma?._id ?? '';
        campoFiltro = 'idEntidad';
        tipoEventoTecnico = 'Evento Técnico Alarma';
        break;
      case 'Evento Luminaria':
        idDispositivo = this.data.luminaria?._id ?? '';
        campoFiltro = 'idEntidad';
        tipoEventoTecnico = 'Evento Técnico Luminaria';
        break;
      case 'Evento Gateway':
        idDispositivo = this.data.gateway?._id ?? '';
        campoFiltro = 'idEntidad';
        tipoEventoTecnico = 'Evento Técnico Gateway';
        break;
      default:
        return;
    }

    if (!idDispositivo) {
      return;
    }

    return new Promise<void>((resolve) => {
      const filter: IFilter<IEventoGenerico> = {
        filtrador: 'Servicio Técnico',
        [campoFiltro]: idDispositivo,
        tipoEvento: tipoEventoTecnico,
        estado: { $ne: 'Finalizado' },
      };

      const populate: IPopulate[] = [
        {
          path: 'detallesTecnicos.tecnico',
          select: 'usuario datosPersonales',
        },
      ];

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        populate: JSON.stringify(populate),
        sort: '-fechaCreacion',
        limit: 1,
      };

      this.servicioTecnicoActivo$?.unsubscribe();
      this.servicioTecnicoActivo$ = this.lista2
        .eventosGenericos(query, 30)
        .subscribe((data) => {
          if (data.datos.length > 0) {
            this.servicioTecnicoActivo = data.datos[0];
            this.estadoServicioTecnico = this.servicioTecnicoActivo
              .detallesTecnicos?.idTecnicoAsignado
              ? 'Asignado'
              : 'Pendiente';
          } else {
            this.servicioTecnicoActivo = undefined;
            this.estadoServicioTecnico = undefined;
          }
          resolve();
        });
    });
  }

  private async listarUltimoReporteTracker(): Promise<void> {
    const idActivo = this.evento.activo?._id;
    if (!idActivo) {
      return;
    }

    return new Promise<void>((resolve) => {
      const filter: IFilter<IReporteGenerico> = {
        idsAsignados: idActivo,
      };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        includeChildren: true,
      };
      this.ultimoReporte$?.unsubscribe();
      this.ultimoReporte$ = this.lista2
        .ultimosReportesGenericos<'Tracker 4G'>(query, 30)
        .subscribe(async (data) => {
          this.ultimoReporte = data.datos[0];
          if (this.ultimoReporte) {
            const res = await this.triperoService.geocode(
              this.ultimoReporte.valores?.geojson.coordinates[1],
              this.ultimoReporte.valores?.geojson.coordinates[0],
            );
            this.direccion = this.helper.extraerDireccion(res.address);
          }
          resolve();
        });
    });
  }

  //

  public verCamaras() {
    const nombreEntidad = this.getNombreEntidad();
    const abierto = this.dialog.openDialogs.find(
      (d) =>
        d.componentInstance instanceof CamarasMultipleComponent &&
        d.componentInstance.nombreEntidad === nombreEntidad,
    );
    // Si ya está abierto (aunque quede detrás del tratamiento), traerlo al
    // frente en vez de no hacer nada.
    if (abierto) {
      (abierto.componentInstance as CamarasMultipleComponent).bringToFront();
      return;
    }

    const esSirena = this.getTipoDispositivo() === 'Sirena';
    const ref = CamarasMultipleComponent.open(
      this.dialog,
      {
        data: esSirena
          ? this.data?.sirena?.idsAsignados
          : this.data?.alarma?.idsCamaras,
        nombreEntidad,
        zonaInicial: esSirena ? undefined : this.camaraInicialAlarma,
        fechaEvento: this.data.fechaCreacion,
      },
      {
        hasBackdrop: false,
        closeOnNavigation: false,
        disableClose: true,
        // El tratamiento abre centrado; posicionamos la cámara arriba-derecha
        // para que NO quede tapada detrás (ambos son dialogs sin backdrop).
        position: { top: '12px', right: '12px' },
      },
    );
    // Además, traerla al frente una vez montada (primer open).
    ref.afterOpened().subscribe(() => ref.componentInstance?.bringToFront());
  }

  private getNombreEntidad(): string {
    return (
      this.data?.alarma?.nombre ||
      this.data?.activo?.identificacion ||
      this.data?.tracker?.nombre ||
      this.data?.luminaria?.identificacion ||
      this.data?.gateway?.nombre ||
      this.data?.botonBluetooth?.mac ||
      this.data?.sirena?.chipId ||
      ''
    );
  }

  // Tratamientos

  public async espera() {
    const config: MatDialogConfig = {
      data: this.idsEventosDispositivoSeleccionados,
    };
    const dialog = this.formularios.abrir(PonerEnEsperaGenericoComponent, {
      tamano: 'chico',
      data: config.data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.dialogRef.close(res);
      }
    });
  }

  public async liberar() {
    const config: MatDialogConfig<{
      idsEventos: string[];
      estado: EstadoEvento;
    }> = {
      data: {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        estado: 'Liberada',
      },
    };
    const dialog = this.formularios.abrir(AgregarNotaGenericoComponent, {
      tamano: 'chico',
      data: config.data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.dialogRef.close(res);
      }
    });
  }

  public async finalizar() {
    const config: MatDialogConfig<{
      idsEventos: string[];
      estado: EstadoEvento;
    }> = {
      data: {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        estado: 'Finalizada',
      },
    };
    const dialog = this.formularios.abrir(AgregarNotaGenericoComponent, {
      tamano: 'chico',
      data: config.data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.dialogRef.close(res);
      }
    });
  }

  public async finalizarTecnico() {
    const config: MatDialogConfig<IAgregarNotaGenericoData> = {
      data: {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        estadoTecnico: 'Finalizado',
        activo: this.data.activo,
        alarma: this.data.alarma,
      },
    };
    const dialog = this.formularios.abrir(AgregarNotaGenericoComponent, {
      tamano: 'chico',
      data: config.data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.dialogRef.close(res);
      }
    });
  }

  public async agregarNota() {
    let data: {
      idsEventos: string[];
      estado?: EstadoEvento;
      estadoTecnico?: EstadoEventoTecnico;
    };
    if (this.esEventoTecnico()) {
      data = {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        estadoTecnico: 'En Atención',
      };
    } else {
      data = {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        estado: 'En Atención',
      };
    }
    const config: MatDialogConfig<{
      idsEventos: string[];
      estado?: EstadoEvento;
      estadoTecnico?: EstadoEventoTecnico;
    }> = {
      data,
    };
    const dialogRef = this.formularios.abrir(AgregarNotaGenericoComponent, {
      tamano: 'chico',
      data: config.data,
    });
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      await this.listarEventos();
      await this.listarTratamientos();
    }
  }

  public async tratar() {
    const res = await this.dialogService.confirm(
      `Confirmá la acción`,
      this.idsEventosDispositivoSeleccionados.length === 1
        ? `¿Tratar evento ${this.data?.valores?.titulo} de ${this.data?.cliente?.nombre}?`
        : `Tratar eventos?`,
    );
    if (!res) return;
    try {
      // Si es técnico usamos estadoTecnico
      let tratamiento: ICreateTratamientoEvento;
      if (this.esEventoTecnico()) {
        tratamiento = {
          estadoTecnico: 'Pendiente',
          idsEventos: this.idsEventosDispositivoSeleccionados,
        };
      } else {
        tratamiento = {
          estado: 'Pendiente',
          idsEventos: this.idsEventosDispositivoSeleccionados,
        };
      }
      await this.service.createGenerico(tratamiento);
      this.helper.notifSuccess('Evento tratado');
      this.tratando = true;
    } catch (error) {
      console.error(error);
      // 403/409: otro operador ya está atendiendo (lock de atención única)
      this.helper.notifError(error);
    }
    // Refresca eventos (arrays de atención) y tratamientos
    await this.listarEventos();
    await this.listarTratamientos();
  }

  public verUbicacion() {
    let geojson = this.getGeojson();

    // Si el evento no tiene geojson, intentar usar el último reporte para tracker/vehículo
    if (!geojson?.coordinates || geojson.coordinates.length < 2) {
      const tiposConUltimoReporte = [
        'Evento Tracker',
        'Evento Activo',
        'Evento Colectivo',
        'Evento Vehiculo',
      ];

      if (
        tiposConUltimoReporte.includes(this.data.tipoEvento) &&
        this.ultimoReporte?.tipoReporte === 'Tracker 4G'
      ) {
        const valores = this.ultimoReporte.valores as {
          geojson?: IGeoJSONPoint;
        };
        if (valores?.geojson) {
          geojson = valores.geojson as IGeoJSONPoint;
        }
      }
    }

    if (!geojson?.coordinates || geojson.coordinates.length < 2) {
      return;
    }

    const lng = geojson.coordinates[0] as number;
    const lat = geojson.coordinates[1] as number;

    const coord = [lng, lat] as [number, number];
    const data: MapaFacilData = {
      markers: [{ coor: coord, label: 'puntoSimple' }],
      satelliteView: true,
    };
    this.formularios.abrir(MapaFacilDialogComponent, {
      tamano: 'grande',
      data,
      cerrarAfuera: true,
    });
  }

  private getGeojson(): IGeoJSONPoint | undefined {
    // Para alarmas, la ubicación está en alarma.domicilio.geojson
    if (this.data.tipoEvento === 'Evento Alarma') {
      return this.data.alarma?.domicilio?.geojson as IGeoJSONPoint | undefined;
    }

    // Para los demás tipos que tienen geojson en valores
    if (
      this.data.tipoEvento === 'Evento Tracker' ||
      this.data.tipoEvento === 'Evento Activo' ||
      this.data.tipoEvento === 'Evento Colectivo' ||
      this.data.tipoEvento === 'Evento Vehiculo' ||
      this.data.tipoEvento === 'Evento Sirena' ||
      this.data.tipoEvento === 'Evento Luminaria' ||
      this.data.tipoEvento === 'Evento Gateway' ||
      this.data.tipoEvento === 'Evento BotonBLE'
    ) {
      return this.data.valores?.geojson as IGeoJSONPoint | undefined;
    }

    return undefined;
  }

  public verServicioTecnico() {
    const idDispositivo = this.data.idEntidad;
    const tipoEvento = this.data.tipoEvento;
    const nombreDispositivo = this.getNombreDispositivo();

    this.formularios.abrir(EventosTecnicosGenericoDispositivoComponent, {
      tamano: 'grande',
      cerrarAfuera: true,
      data: {
        idDispositivo,
        tipoEvento,
        nombreDispositivo,
      },
    });
  }

  private getNombreDispositivo(): string {
    switch (this.data.tipoEvento) {
      case 'Evento Activo':
      case 'Evento Colectivo':
      case 'Evento Vehiculo':
        return this.data.activo?.identificacion || 'Activo';
      case 'Evento Alarma':
        return this.data.alarma?.nombre || 'Alarma';
      case 'Evento Tracker':
        return this.data.tracker?.nombre || 'Tracker';
      case 'Evento Luminaria':
        return this.data.luminaria?.identificacion || 'Luminaria';
      case 'Evento Gateway':
        return this.data.gateway?.nombre || 'Gateway';
      case 'Evento BotonBLE':
        return 'Botón BLE';
      case 'Evento Sirena':
        return this.data.sirena?.chipId || 'Sirena';
      default:
        return 'Dispositivo';
    }
  }

  private getTipoDispositivo(): string {
    switch (this.data.tipoEvento) {
      case 'Evento Activo':
      case 'Evento Colectivo':
      case 'Evento Vehiculo':
        return 'Activo';
      case 'Evento Alarma':
        return 'Alarma';
      case 'Evento Tracker':
        return 'Tracker';
      case 'Evento BotonBLE':
        return 'BotonBLE';
      case 'Evento Sirena':
        return 'Sirena';
      case 'Evento Luminaria':
        return 'Luminaria';
      case 'Evento Gateway':
        return 'Gateway';
      case 'Evento Técnico Alarma':
        return 'Alarma';
      case 'Evento Técnico Tracker':
        return 'Tracker';
      case 'Evento Técnico Luminaria':
        return 'Luminaria';
      case 'Evento Técnico Gateway':
        return 'Gateway';
      case 'Evento Técnico Sirena':
        return 'Sirena';
      default:
        return '';
    }
  }

  public verHistoricoEventos() {
    const idDispositivo = this.data.idEntidad || '';
    const tipo = this.getTipoDispositivo();

    this.formularios.abrir(HistoricoEventoGenericoDialogComponent, {
      tamano: 'grande',
      cerrarAfuera: true,
      data: { idDispositivo, tipo, tipoEvento: this.data.tipoEvento },
    });
  }

  public asignarTecnico() {
    if (!this.esEventoTecnico()) {
      return;
    }

    const data = {
      id: this.data._id,
      idTecnico: this.data.detallesTecnicos?.idTecnicoAsignado,
    };

    const dialogRef = this.formularios.abrir(AsignarGenericoComponent, {
      tamano: 'mediano',
      data,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        // Recargar el evento para actualizar la info del técnico
        await this.recargarEvento();
      }
    });
  }

  private async recargarEvento(): Promise<void> {
    try {
      const eventoActualizado = await this.eventosGenericosService.getById(
        this.data._id,
      );

      // Actualizar el data del componente con el evento recargado
      this.data = eventoActualizado;
    } catch (error) {
      console.error('Error al recargar evento:', error);
      this.helper.notifError('Error al actualizar la información del evento');
    }
  }

  public verFotos() {
    /// TODO: implementar
  }

  public async verVecino() {
    if (this.data.tipoEvento === 'Evento Sirena') {
      // `valores.idVecino` (gestion-modelos) ya trae el `_id` del ConfigVecino de
      // seguridad (lo envían seguridad-sirenas-go / api-sirenas-mqtt). El nombre del
      // campo es histórico: se mantiene por los eventos persistidos y la app irix.
      const idConfigVecino = this.data.valores?.idVecino;
      const idCliente = this.data.idCliente;
      if (idConfigVecino) {
        const { DetallesVecinoComponent } =
          await import('../../../sirenas/detalles-vecino/detalles-vecino.component');
        this.formularios.abrir(DetallesVecinoComponent, {
          tamano: 'grande',
          data: { idConfigVecino, idCliente },
          cerrarAfuera: true,
        });
      }
    }
  }

  public minimizar(): void {
    const titulo =
      (this.data.valores as any)?.titulo ||
      this.data.tipoEvento ||
      'Tratamiento';
    const subtitulo =
      this.data.activo?.identificacion ||
      this.data.tracker?.identificacion ||
      undefined;
    this.tratamientoMinimizado.minimizar(this.dialogRef, { titulo, subtitulo });
  }

  public closeDialog() {
    this.tratamientoMinimizado.cerrar();
    this.dialogRef.close();
  }

  // Un clic en cualquier parte del diálogo lo trae al frente. Va en el host y
  // no como (click) en el contenedor de la plantilla: es una superficie, no un
  // botón.
  @HostListener('click')
  public alClicEnDialogo(): void {
    this.bringToFront();
  }

  public bringToFront(): void {
    // Asegurar que el boundary esté configurado
    if (!this.dragBoundary) {
      this.setupDragBoundary();
    }

    const dialogsContainer = Array.from(
      this.cdk.getContainerElement().childNodes,
    );
    const dialogContainerTagName = 'MAT-DIALOG-CONTAINER';
    const parentEl = this.el.nativeElement.closest(dialogContainerTagName);
    const dialogId = parentEl?.getAttribute('id');
    const previousDialog = this.cdk.getContainerElement().lastElementChild;
    const focusedDialog = (dialogsContainer as HTMLElement[]).find(
      (el: HTMLElement) => {
        return el.querySelector(`#${dialogId}`);
      },
    );
    // para evitar que el scroll se resetee si es el mismo dialog
    if (focusedDialog !== previousDialog) {
      if (focusedDialog) {
        // appendChild moves the element to the end of the container
        this.cdk.getContainerElement().appendChild(focusedDialog);
      } else {
        console.error('Dialog not found with id:', dialogId);
      }
    }
  }

  public marcado(evento: IEventoGenerico) {
    return this.idsEventosDispositivoSeleccionados?.includes(evento._id);
  }

  public marcarTodos(checked: boolean) {
    if (checked) {
      this.idsEventosDispositivoSeleccionados = this.eventosDispositivo.map(
        (e) => e._id,
      );
    } else this.idsEventosDispositivoSeleccionados = [];
  }

  public cambiarMarcado(marcado: boolean, evento: IEventoGenerico) {
    if (marcado) {
      this.idsEventosDispositivoSeleccionados.push(evento?._id);
    } else {
      this.idsEventosDispositivoSeleccionados =
        this.idsEventosDispositivoSeleccionados.filter((s) => s !== evento._id);
    }
  }

  public camaraInicial() {
    // Solo los eventos de alarma tienen particion y zona en contactId
    if (this.data.tipoEvento === 'Evento Alarma') {
      const particion = this.data.valores?.contactId?.numeroDeParticion;
      const zona = this.data.valores?.contactId?.numeroDeZona;

      if (particion && zona && this.data.alarma?.camarasPorZona) {
        const res = this.data.alarma.camarasPorZona.find(
          (c) => +c.particion === +particion && +c.zona === +zona,
        );
        if (res) this.camaraInicialAlarma = res;
      }
    }
  }
  /// Movil

  public tieneEnvioMovil(): boolean {
    const envios = ['envío móvil', 'envio movil'];

    return (
      !!this.data.alarma?._id &&
      this.serviciosContratados.some((s) =>
        envios.includes(s.nombre?.toLowerCase() ?? ''),
      )
    );
  }

  public async enviarMovil() {
    // Obtener la posición según el tipo de evento
    let position: IGeoJSONPoint | undefined;

    if (this.evento.tipoEvento === 'Evento Alarma') {
      position = this.evento.alarma?.domicilio?.geojson as
        | IGeoJSONPoint
        | undefined;
    } else if (
      this.evento.tipoEvento === 'Evento Tracker' ||
      this.evento.tipoEvento === 'Evento Activo' ||
      this.evento.tipoEvento === 'Evento Colectivo' ||
      this.evento.tipoEvento === 'Evento Vehiculo' ||
      this.evento.tipoEvento === 'Evento Sirena' ||
      this.evento.tipoEvento === 'Evento Luminaria' ||
      this.evento.tipoEvento === 'Evento Gateway' ||
      this.evento.tipoEvento === 'Evento BotonBLE'
    ) {
      position = this.evento.valores?.geojson as IGeoJSONPoint | undefined;
    }

    const config: MatDialogConfig<{
      idsEventos: string[];
      position?: IGeoJSONPoint;
    }> = {
      data: {
        idsEventos: this.idsEventosDispositivoSeleccionados,
        position,
      },
    };
    this.formularios.abrir(EnviarMovilComponent, {
      tamano: 'grande',
      data: config.data,
    });
  }

  //

  private checkearCamaras() {
    // Si data tiene tiene alarma o sirena
    // y la alarma o sirena tiene camaras es true
    if (
      (this.data?.alarma?._id && this.data.alarma?.idsCamaras?.length) ||
      (this.data?.sirena?._id && this.data.sirena?.idsAsignados?.length)
    ) {
      this.tieneCamaras.set(true);
    } else {
      this.tieneCamaras.set(false);
    }
  }

  //

  /**
   * Verifica si el evento actual es un evento técnico
   * @returns true si el tipo de evento comienza con 'Evento Técnico'
   */
  public esEventoTecnico(): boolean {
    return this.data.tipoEvento?.startsWith('Evento Técnico') ?? false;
  }

  /**
   * Navega a los detalles de la entidad según el tipo de evento
   */
  public async verDetallesEntidad(): Promise<void> {
    //SIRENAS
    if (this.data.sirena?._id) {
      // El detalle de la integración es una página (antes un diálogo)
      this.minimizar();
      this.router.navigate(
        [
          '/main/sirenas/sirenas/detalles',
          this.data.sirena.idExterno || this.data.sirena._id,
        ],
        {
          queryParams: this.data.sirena.idCliente
            ? { cliente: this.data.sirena.idCliente }
            : {},
        },
      );
      return;
    }

    let ruta: string[] = [];

    //ALARMAS
    if (this.data.alarma?._id) {
      ruta = [
        '/main/alarmas/alarmasDomiciliarias/detallesAlarma',
        this.data.alarma._id,
      ];
    }
    //ACTIVO
    else if (this.data.activo?._id && this.data.activo.categoria === 'Normal') {
      ruta = ['/main/activos/activos/detalles', this.data.activo._id];
    }

    //VEHÍCULO
    else if (
      this.data.activo?._id &&
      this.data.activo.categoria === 'Vehículo'
    ) {
      ruta = ['/main/vehiculos/vehiculos/detalles', this.data.activo._id];
    }

    //COLECTIVO
    else if (
      this.data.activo?._id &&
      this.data.activo.categoria === 'Colectivo'
    ) {
      ruta = ['/main/colectivos/colectivos/detalles', this.data.activo._id];
    }

    //TRACKER
    else if (this.data.tracker?._id) {
      ruta = [
        '/main/administracion/trackers/detallesTracker',
        this.data.tracker._id,
      ];
    }
    //LUMINARIA
    else if (this.data.luminaria?._id) {
      ruta = ['/main/luminarias/luminarias/detalles', this.data.luminaria._id];
    }
    //GATEWAY
    else if (this.data.gateway?._id) {
      ruta = ['/main/administracion/gateways/detalles', this.data.gateway._id];
    }
    //BOTÓN BLUETOOTH
    else if (this.data.botonBluetooth?._id) {
      ruta = [
        '/main/administracion/botones-ble/detalles',
        this.data.botonBluetooth._id,
      ];
    }

    if (ruta.length) {
      this.minimizar();
      this.router.navigate(ruta);
    }
  }

  /**
   * Verifica si el evento es de un vehículo
   */
  public esEventoVehiculo(): boolean {
    return (
      this.data.tipoEvento === 'Evento Vehiculo' || !!this.data.activo?.vehiculo
    );
  }

  /** Tracker asociado al evento, venga por la entidad o por el activo. */
  private get trackerDelEvento() {
    return this.data?.tracker ?? this.data?.activo?.tracker;
  }

  /**
   * ¿Se puede declarar una emergencia AVL desde este evento?
   *
   * Pide las dos cosas: que el evento sea de un vehículo o de un tracker (el
   * reenvío se declara sobre la entidad tracker), y que el cliente tenga la
   * integración cargada — sin URL ni token no hay con qué transmitir.
   *
   * Ojo: `getCliente()` sale de sessionStorage, así que si acaban de cargar
   * las credenciales el botón aparece recién en la próxima sesión.
   */
  public puedeDeclararEmergenciaAvl(): boolean {
    const avl = LoginService.getCliente()?.config?.integracionObjetivosAVL;
    if (!avl?.activo || !avl?.url || !avl?.token) return false;
    return (
      !!this.trackerDelEvento?._id &&
      (this.esEventoVehiculo() || this.data?.tipoEvento === 'Evento Tracker')
    );
  }

  /** Abre el popup de emergencia AVL sobre el tracker del evento. */
  public declararEmergenciaAvl(): void {
    const tracker = this.trackerDelEvento;
    if (!tracker?._id) return;
    this.formularios.abrir<EmergenciaAvlDialogComponent, IEmergenciaAvlData>(
      EmergenciaAvlDialogComponent,
      {
        tamano: 'mediano',
        data: {
          idTracker: tracker._id,
          nombreEntidad:
            this.data?.activo?.vehiculo?.patente ??
            this.data?.activo?.identificacion ??
            tracker.identificacion ??
            undefined,
          patente: this.data?.activo?.vehiculo?.patente,
          uniqueId: tracker.uniqueId,
        },
      },
    );
  }

  /**
   * Verifica si el evento es de un vehículo (activo)
   */
  public esEventoVehiculoActivo(): boolean {
    return !!this.data.activo?._id;
  }

  /**
   * Carga el último certificado del vehículo asociado al evento
   */
  private async cargarUltimoCertificado(): Promise<void> {
    const idEntidad = this.data.activo?._id;
    if (!idEntidad) return;

    const filter: IFilter<ICertificadoEntidad> = { idEntidad };
    const populate: IPopulate = [
      { path: 'tracker', select: 'identificacion' },
      { path: 'activo', select: 'identificacion' },
      { path: 'cliente', select: 'nombre' },
    ] as any;
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      populate: JSON.stringify(populate),
      limit: 1,
      sort: '-fechaComienzo',
    };

    const resultado = await this.certificadoEntidadService.getFiltered(query);
    this.ultimoCertificado = resultado.datos?.[0] ?? null;
  }

  /**
   * Abre el dialog para ver el último certificado del tracker o vehículo
   */
  public verCertificado(): void {
    if (!this.ultimoCertificado) return;

    this.formularios.abrir(VerCertificadoEntidadComponent, {
      tamano: 'grande',
      data: { certificado: this.ultimoCertificado },
      cerrarAfuera: true,
    });
  }

  /**
   * Navega al mapa de vehículos y selecciona el vehículo del evento
   */
  public verEnMapa(): void {
    const activoId = this.data.activo?._id;
    if (!activoId) return;

    // Seteamos el vehículo pendiente para que el mapa lo seleccione al cargar
    this.mapaVehiculosService.setPendingVehicleActivoId(activoId);

    this.minimizar();
    this.router.navigate(['/main/vehiculos/mapa']);
  }

  /**
   * Verifica si la alarma tiene control horario configurado y activo
   */
  public tieneControlHorario(): boolean {
    return this.data.categoria === 'Control Horario';
  }

  /**
   * Navega al control horario de la alarma. Por nombre: el índice de la
   * pestaña cambia según las que el usuario tiene por permiso.
   */
  public verControlHorario(): void {
    if (this.data.alarma?._id) {
      this.minimizar();
      this.router.navigate(
        [
          '/main/alarmas/alarmasDomiciliarias/detallesAlarma',
          this.data.alarma._id,
        ],
        {
          queryParams: { tab: 'controlHorario' },
        },
      );
    }
  }

  async ngOnInit() {
    this.paramsService.setParams({ dialog: false });
    try {
      this.data = await this.eventosGenericosService.getById(
        this.dialogData.idEvento,
      );
    } catch (error) {
      console.error('Error al cargar evento:', error);
      this.helper.notifError('Error al cargar el evento');
      this.dialogRef.close();
      return;
    }
    this.evento = this.data;
    this.checkearCamaras();
    this.comunicadoresResueltos = await firstValueFrom(
      this.modeloCache.resolverModelosComunicadores(
        this.data.alarma?.comunicadores,
      ),
    );

    this.estadoActual = this.data?.estado as EstadoEvento;

    const usuario = LoginService.getUsuario();
    if (this.data.idsUsuariosAtendiendo?.includes(usuario._id)) {
      this.tratando = true;
    }
    this.actualizarUsuariosAtendiendo([this.data]);

    await Promise.all([
      this.listarEventos(),
      this.listarNotas(),
      this.listarCliente(),
      this.listarUltimosEventos(),
      this.listarServicios(),
      this.listarServicioTecnicoActivo(),
      this.listarUltimoReporteTracker(),
      this.cargarUltimoCertificado(),
      this.listarMateriales(),
    ]);
    // Para eventos técnicos no se requiere el paso de "Iniciar Tratamiento"
    if (this.esEventoTecnico()) {
      this.tratando = true;
    }
    this.camaraInicial();
    this.loading = false;

    // Configurar el boundary después de que termine la carga
    this.setupDragBoundary();
  }

  private setupDragBoundary(): void {
    // Intentar obtener el elemento router
    const routerElement = document.getElementById('router');

    if (routerElement) {
      this.dragBoundary = routerElement;
    } else {
      // Fallback: usar el contenedor del overlay como boundary
      const overlayContainer = this.cdk.getContainerElement();
      if (overlayContainer) {
        this.dragBoundary = overlayContainer;
      } else {
        // Último fallback: usar el viewport
        this.dragBoundary = document.body;
      }
    }
  }

  async ngOnDestroy() {
    this.tratamientoMinimizado.cerrar();
    this.tratamientosEvento$?.unsubscribe();
    this.notas$?.unsubscribe();
    this.cliente$?.unsubscribe();
    this.evento$?.unsubscribe();
    this.servicioTecnicoActivo$?.unsubscribe();
    this.materiales$?.unsubscribe();
    this.ultimosEventos$?.unsubscribe();
    this.serviciosContratados$?.unsubscribe();
    this.ultimoReporte$?.unsubscribe();
  }
}
